import i18n from 'i18next'

/**
 * A helper to minimize code size when working with translatable copies
 */
export const getCopies = <T = string>(key: string): T => {
  // @ts-ignore
  return i18n.t(key, { returnObjects: true })
}
